var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoginForm
    ? _c("login-form", {
        attrs: { "create-link": _vm.createLink },
        on: { goToForgotPassword: _vm.toggleForgotPassword }
      })
    : _c("password-form", {
        attrs: { "forgot-password-link": _vm.forgotPasswordLink },
        on: { goToLogin: _vm.backToLogin }
      })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bdc8b8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bdc8b8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Login.vue
// module id = 570
// module chunks = 1